import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type tabletState = {
  isTablet: boolean;
};

const initState: tabletState = {
  isTablet: false,
};

const tabletSlice = createSlice({
  name: 'tabletSlice',
  initialState: initState,
  reducers: {
    setTablet: (state, action: PayloadAction<boolean>) => {
      state.isTablet = action.payload;
    },
  },
});

export const { setTablet } = tabletSlice.actions;
export default tabletSlice.reducer;
